import React from 'react'
import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {MediaBase} from "../components/media/MediaBase";

// STYLE ##########################################################


// COMPONENT ##########################################################

export function Welcome() {

    return (
        <StyledMedia>
            <Container isMobile={isMobileOnly}>
                <Header hideOrderOrPortfolio={true} />
                <MediaBase />
                <Footer />
            </Container>
        </StyledMedia>
    )
}